export const LEAD_ACCEPTANCE = {
  DISCLAIMER: 'By accepting this referral I agree that it is subject to the governing Master Listing and Broker Referral Agreement and Broker Guidelines, and I further agree to complete and return the necessary Xome Agent Network Supplemental to Xome.',
  CONFLICT_MESSAGE: 'Lead no longer available!',
  ACTION: {
    UPDATE_LEAD_ACCEPTANCE: 'UPDATE_LEAD_ACCEPTANCE',
    SET_LEAD_ACCEPTANCE: 'SET_LEAD_ACCEPTANCE',
    ACCEPTED_LEAD: 'ACCEPTED_LEAD'
  }
};
